import { render } from "./ModuleSearchField.vue?vue&type=template&id=63b948eb"
import script from "./ModuleSearchField.vue?vue&type=script&lang=js"
export * from "./ModuleSearchField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__